<div class="divider">
  <ng-content></ng-content>
</div>
